/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { ChecklistRestService } from '@gh/builder-shared-data';
import { EntityInputDialogConfig } from '@gh/common-internal-shared';
import { InitDialogViewService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogRouteSnapshot } from '@gh/core-ui';

import { Observable } from 'rxjs';

import { ChecklistItem } from './checklist.model';

@Injectable()
export class ChecklistListBusinessService implements InitViewService, InitDialogViewService<EntityInputDialogConfig<ChecklistItem>> {
  constructor(private checklistRest: ChecklistRestService) {

  }

  initView(): any {
    return {
      checklist: this.findAll(),
    };
  }

  initDialogView(route: DialogRouteSnapshot<EntityInputDialogConfig<ChecklistItem>>): any {
    return route.input.id ? this.get(route.input.id) : this.prepareForCreate();
  }

  prepareForCreate(): ChecklistItem {
    return {
      id: '',
      name: '',
    };
  }

  create(checklistItem: ChecklistItem): Observable<ChecklistItem> {
    return this.checklistRest.create(checklistItem);
  }

  delete(id: ID): Observable<ChecklistItem> {
    return this.checklistRest.delete(id);
  }

  update(checklistItem: ChecklistItem): Observable<ChecklistItem> {
    return this.checklistRest.update(checklistItem);
  }

  updateOrder(checkLIst: ChecklistItem[]): Observable<ChecklistItem[]> {
    return this.checklistRest.updateOrder(checkLIst);
  }

  get(id: ID): Observable<ChecklistItem> {
    return this.checklistRest.get(id);
  }

  findAll(): Observable<ChecklistItem[]> {
    return this.checklistRest.findAll();
  }
}
